import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import { DOWNLOAD_ARN_LOADING, DOWNLOAD_ARN_SUCCESS, DOWNLOAD_ARN_FAILED } from "../Constants/downloadArnConstants";
import { handleApiError } from "../Helper/actionHelper";

export const getArn = (isMRL) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    const fetchUrl="downloadArnTemplate";
    dispatch({ type: DOWNLOAD_ARN_LOADING });

    const requestData = { 
      token:
      userLocalData.id,
     
    };
    if(isMRL){
      requestData.isMRL = 1;
    }

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const {data}=fetch(FOLDERPATH + "/ClientApi/" + fetchUrl,
    {body:JSON.stringify(requestData), 
      headers,
      method: 'POST',}).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = 'ARNTemplate.pdf';
        alink.click();
      });
    });

    dispatch({
      type: DOWNLOAD_ARN_SUCCESS,
      payload: data,
    });

    handleApiError(data);

  } catch (error) {
    dispatch({
      type: DOWNLOAD_ARN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};


export const downloadManualARNTemplate = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    const fetchUrl="downloadCandidateArnTemplate";
    dispatch({ type: DOWNLOAD_ARN_LOADING });

    const requestData = { 
      token:
      userLocalData.id,
     
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const {data}=fetch(FOLDERPATH + "/CandidateApi/" + fetchUrl,
    {body:JSON.stringify(requestData), 
      headers,
      method: 'POST',}).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = 'ARNTemplate.pdf';
        alink.click();
      });
    });

    dispatch({
      type: DOWNLOAD_ARN_SUCCESS,
      payload: data,
    });

    handleApiError(data);

  } catch (error) {
    dispatch({
      type: DOWNLOAD_ARN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};